import googleTranslate from './googleTranslatePlugin/doGTranslate';

export default {
    setLang: function (lang, { needRefresh } = { needRefresh: true }) {
        var translatorType =
            window.siteAppVm?.$store.state.page.page?.translatorType;
        switch (translatorType) {
            case 'chime':
                window.siteAppVm.changeLanguage(lang, { needRefresh });
                break;
            case 'googlePlugin':
                googleTranslate(lang);
                break;
        }
    },
    googleTranslate: googleTranslate
};
